module.exports = __webpack_public_path__ + "img/tree-center.8b47b7ef.svg";